/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useState, useEffect, useRef } from "react";
import { cn } from "tailwind-variants";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { isArtworkWithError } from "./utils";
import { useDtfStore } from "./store";
import { useSpanglesStore } from "./spangles-module";
import "./DropZone.scss";

export default function DropZone({ ...restProps }) {
  const store = useDtfStore();
  const spanglesStore = useSpanglesStore();
  const [dropzoneVisible, setDropzoneVisible] = useState(false);
  const dropzoneRef = useRef(null);

  // Computed properties
  function artworks() {
    // @ts-expect-error TS(4111): Property 'artworks' comes from an index signature,... Remove this comment to see the full error message
    return store.artworks;
  }

  function showModal() {
    // @ts-expect-error TS(4111): Property 'showModal' comes from an index signature... Remove this comment to see the full error message
    return store.showModal;
  }

  function isSpangle() {
    // @ts-expect-error TS(4111): Property 'isSpangle' comes from an index signature... Remove this comment to see the full error message
    return store.isSpangle;
  }

  function isPuff() {
    // @ts-expect-error TS(4111): Property 'isPuff' comes from an index signature, s... Remove this comment to see the full error message
    return store.isPuff;
  }

  function isStickerSample() {
    // @ts-expect-error TS(4111): Property 'isStickerSample' comes from an index sig... Remove this comment to see the full error message
    return store.isStickerSample;
  }

  function spanglesMaxImageCount() {
    // @ts-expect-error TS(4111): Property 'spanglesMaxImageCount' comes from an ind... Remove this comment to see the full error message
    return spanglesStore.spanglesMaxImageCount;
  }

  /* TODO(vue-migration): artwork property not defined in Vue component; may be from store or parent */
  function artwork() {
    // @ts-expect-error TS(4111): Property 'artwork' comes from an index signature, ... Remove this comment to see the full error message
    return store.artwork;
  }

  function metadata() {
    // @ts-expect-error TS(2339): Property 'removeBackground' does not exist on type... Remove this comment to see the full error message
    const { removeBackground, metadata: metadataValue, withBgMetadata } = artwork() || {};
    if (!withBgMetadata) {
      return metadataValue;
    }
    return removeBackground ? metadataValue : withBgMetadata;
  }

  // @ts-expect-error TS(6133): 'withErrors' is declared but its value is never re... Remove this comment to see the full error message
  function withErrors() {
    return metadata()?.errors?.length > 0 && !showModal();
  }

  /* TODO(vue-migration): replaceArtwork property not defined; may be from store */
  function replaceArtwork() {
    // @ts-expect-error TS(4111): Property 'replaceArtwork' comes from an index sign... Remove this comment to see the full error message
    return store.replaceArtwork;
  }

  function addFilesToQueue(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return store.addFilesToQueue(...args);
  }

  function removeArtworkByIndex(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return store.removeArtworkByIndex(...args);
  }

  function setReplaceArtwork(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return store.setReplaceArtwork(...args);
  }

  useEffect(() => {
    function handleDrop(e: any) {
      e.preventDefault();
      setDropzoneVisible(false);
      const { files } = e.dataTransfer;
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const userArtworks = artworks().filter((artworkItem: any) => !artworkItem.isSimulated);
      let artworkIndex = null;
      submitDtfEvent("file_drop_detected", { file_count: files.length });
      if (
        files.length > 10 ||
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        (isSpangle() && files.length > spanglesMaxImageCount()) ||
        ((isPuff() || isStickerSample()) && (userArtworks.length > 0 || files.length > 1))
      ) {
        return;
      }
      if (files.length <= 1 && replaceArtwork()) {
        artworkIndex = 0;
      } else {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        artworks().forEach((artworkItem: any, index: any) => {
          if (isArtworkWithError(artworkItem)) {
            removeArtworkByIndex(index);
          }
        });
      }
      addFilesToQueue({
        files,
        isDropEvent: true,
        artworkIndex
      });
      setReplaceArtwork(false);
    }

    function hideDropzone(e: any) {
      e.preventDefault();
      setDropzoneVisible(false);
    }

    function showDropzone(e: any) {
      e.preventDefault();
      setDropzoneVisible(true);
    }

    window.addEventListener("dragenter", showDropzone);
    window.addEventListener("dragover", showDropzone);
    window.addEventListener("drop", handleDrop);
    window.addEventListener("dragleave", hideDropzone);

    return () => {
      window.removeEventListener("dragenter", showDropzone);
      window.removeEventListener("dragover", showDropzone);
      window.removeEventListener("drop", handleDrop);
      window.removeEventListener("dragleave", hideDropzone);
    };
  }, []);

  return (
    <div
      {...restProps}
      // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
      className={cn("dropzone scope-b4d4a469", !dropzoneVisible && "hidden", restProps?.className)}
      ref={dropzoneRef}
    >
      <div className="dropzone__inner scope-b4d4a469">
        {" "}
        Drag and Drop <br className="scope-b4d4a469" /> Your Files Anywhere{" "}
      </div>
    </div>
  );
}
